"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var findNextValue_1 = __importDefault(require("./findNextValue"));
var cache = __importStar(require("./cache"));
/**
 * Finds a value in an object by the given path in dot notation.
 * @param {unknown} source - The object to search within.
 * @param {string} path - The path to the value in dot notation.
 * @returns {unknown} The value found at the given path, or undefined if not found.
 */
var findValueByPath = function (source, path) {
    if (cache.has(path))
        return cache.get(path);
    var segments = path.split(".");
    var nextValue = {
        fullPath: path,
        currentPath: undefined,
        value: source,
    };
    for (var _i = 0, segments_1 = segments; _i < segments_1.length; _i++) {
        var segment = segments_1[_i];
        nextValue = (0, findNextValue_1.default)(nextValue, segment);
        if (nextValue.value === undefined)
            break;
    }
    cache.set(path, nextValue.value);
    return nextValue.value;
};
exports.default = findValueByPath;
